export const dateConfig = (preferredLanguage?: "fr" | "en") => {
  if (preferredLanguage === "fr") {
    return "fr-FR";
  } else if (preferredLanguage === "en") {
    return "en-US";
  } else {
    return "en-GB";
  }
};
